export const FILTER_STATUSES = 'statuses';
export const FILTER_PARTNER_COMPANIES = 'partnerCompanies';
export const FILTER_BUSINESS_PARTNERS = 'businessPartners';
export const FILTER_CAMPAIGN_NETWORKS = 'campaignNetworks';
export const FILTER_CAMPAIGN_APPLICATIONS = 'campaignApplications';
export const FILTER_CAMPAIGN_PLATFORMS = 'campaignPlatforms';
export const FILTER_CAMPAIGN_CLUSTERS = 'campaignClusters';
export const FILTER_TRAFFIC_TYPES = 'trafficTypes';
export const FILTER_EXPENSE_TYPES = 'expenseTypes';
export const FILTER_OWNERS = 'owners';
export const FILTER_CREATED_BY = 'creators';
export const FILTER_CHANNELS = 'channels';
export const FILTER_CHANNEL_TYPE = 'channelType';

export const FILTERS_DEPENDENCIES = {
  [FILTER_BUSINESS_PARTNERS]: [FILTER_PARTNER_COMPANIES],
  [FILTER_CAMPAIGN_NETWORKS]: [FILTER_CAMPAIGN_APPLICATIONS],
  [FILTER_CAMPAIGN_APPLICATIONS]: [FILTER_CAMPAIGN_NETWORKS],
  [FILTER_CAMPAIGN_PLATFORMS]: [
    FILTER_CAMPAIGN_NETWORKS,
    FILTER_CAMPAIGN_APPLICATIONS,
  ],
  [FILTER_CAMPAIGN_CLUSTERS]: [
    FILTER_CAMPAIGN_NETWORKS,
    FILTER_CAMPAIGN_APPLICATIONS,
  ],
  [FILTER_OWNERS]: [FILTER_PARTNER_COMPANIES, FILTER_BUSINESS_PARTNERS],
  [FILTER_CREATED_BY]: [FILTER_PARTNER_COMPANIES, FILTER_BUSINESS_PARTNERS],
  [FILTER_CHANNELS]: [FILTER_CHANNEL_TYPE],
};

export const COLUMN_ID = 'id';
export const COLUMN_NAME = 'name';
export const COLUMN_STATUS = 'status';
export const COLUMN_PARTNER_COMPANY = 'partnerCompany';
export const COLUMN_BUSINESS_PARTNER = 'businessPartner';
export const COLUMN_NETWORK = 'network';
export const COLUMN_TRAFFIC_TYPES = 'trafficTypes';
export const COLUMN_EXPENSE_TYPE = 'expenseType';
export const COLUMN_OWNER = 'owner';
export const COLUMN_CREATED_BY = 'createdBy';
export const COLUMN_UPDATED_DATE = 'lastUpdatedDate';
export const COLUMN_CHANNEL = 'channel';
export const COLUMN_ADDITIONAL_FEE = 'additionalFee';
export const COLUMN_CREATED_DATE = 'createdDate';

export const ACTION_ARCHIVE = 'Deactivate';
export const ACTION_RESTORE = 'Activate';
export const ACTION_MOVE_TO_TEST = 'Move to Test';
export const ACTION_QA = 'QA';
export const ACTION_EDIT = 'Edit';

export const STATUS_ACTIVE = 0;
export const STATUS_ARCHIVED = 1;
export const STATUS_IN_TEST = 2;
export const STATUS_QA = 3;

export const TAB_DETAILS = 'details';
export const TAB_ACTIONS_LOG = 'Actions Log';
